import api from '~/api'
import Cookies from '~/cookie'
import { parseStatsToProducts } from '~/utils'

const isProd = process.env.NODE_ENV === 'production'
const LOOP_COUNT = isProd ? 5 : 1

const userActions = [
  'queroRevender',
  'queroRevenderCancelar',
  'queroRevenderEnvioForm',
  'buscaProduto',
  'selecionarProduto',
  'cliqueProdutoDetalhes',
  'linkProdutoDetalhes',
  'reportarProblema',
  'cliqueVerTelefone',
  'cliqueRota',
  'souEmpresa',
  'ativarLocalização',
  'alterarLocalização',
  'cliqueMarca',
  'busca',
  'verMaisProdutos',
  'cliqueLigar',
  'cliqueWhats',
  'comprarOnline',
  'rappi',
  'compartilharProduto',
  'copiarProduto',
  'reivindicarLoja',
  'cliqueVerLoja',
  'encontrarLojaFisica',
  'saibaMais', // Landing page
  'caldobom', // Landing page
  'casadiconti', // Landing page
  'dentalclean', // Landing page
  'nescau', // Landing page
  'ninho', // Landing page
  'whatsappTotal',
  'expandirMapaProduto',
  'cliqueVerTodosOsProdutos',
  'expandirMapaLoja',
  'cliqueVerTodasAsLojas',
  'clickMapaProdutos',
  'clickMapaLoja',
  'naoLocalizadoProximo-SemEcommerce',
  'naoLocalizadoProximo',
  'naoLocalizadoProximo-CliqueRedirect',
  'naoLocalizadoLojaOnline',
  'naoLocalizadoLojaOnline-CliqueRedirect',
  'escolherLocalizacao',
  'ajustarLocal',
  'compartilharLocal',
  'buscarQualquerProduto',
  'storeOnline',
  'verLojaOnline',
  'proximoFormWhats',
  'fecharFormWhats',
  'voltarFormWhats',
  'iniciarConversarFormWhats',
  'permissaoSaibaMais',
  'digitarEndereco',
  'compartilharEndereco',
  'permissaoLocalNegada',
  'infoUtilSim',
  'infoUtilNao',
  'cliqueFotosLoja',
  'cliqueHorarios',
  'ctaiFood',
  'cliqueLojaOnline',
  'comprarOnline-URL',
  'comprarOnline-GoogleShopping',
  'lojaOnlineListada',
]

export default function track(event, data = {}, loop = 1) {
  const isAnonymous = Cookies.get('session-mode')?.toLowerCase().includes('anonimo')

  if (isAnonymous) {
    console.warn(`~ 🥷 ANONYMOUS MODE AVAILABLE - event "${event}" not sent ~ \n`, data)
    return
  }

  try {
    // if (process.env.NODE_ENV !== 'production') return

    let nonInteraction = true

    if (userActions.includes(event)) {
      nonInteraction = false
    }

    //Não adicionar o atributo event_action, pois o mesmo renomeia o evento e causa problemas de rastreamento
    const eventParams = {
      non_interaction: nonInteraction,
      event_label: data?.name?.concat?.(data?.zipcode ? `-${data?.zipcode}` : ''),
      event_category: data?.category,
      affiliation: data?.affiliation,
    }

    console.log('🚩 event', event, eventParams)

    if (window.gtag) {
      if (event === 'product:selectProduct') {
        return window.gtag('event', 'Procurar Produto', {
          event_label: data.name,
        })
      }

      window.gtag('event', event, eventParams)
    } else if (loop < LOOP_COUNT) {
      setTimeout(() => {
        track(event, data, loop + 1)
      }, 1000)
    }
  } catch (e) {
    console.log(e)
  }
}

// ex.: data = {event: 'route'}
export function log(data, config, currentStore, product, user) {
  const { name, cnpj, suppliers, stats } = currentStore

  const logParams = {
    ...data,
    name,
    cnpj,
    suppliers,
    products: parseStatsToProducts(stats),
    brand: config.isOndetem ? product.brand : null,
    user,
  }

  return api.clickTrack(logParams)
}

export function cliqueLoja(config, store, product, user, category = 'menu') {
  track('cliqueVerLoja', { category, name: store?.name, zipcode: store?.zipcode })
  log({ event: 'store' }, config, store, product, user)
}

export function cliqueRota(config, store, product, user) {
  if (store?.place) {
    window.open(store.place.url)
  } else {
    window.open(`http://maps.google.com/?q=${store.coordinates.formattedAddress}`)
  }
  track('cliqueRota', { category: 'menu', name: store.name })
  log({ event: 'route' }, config, store, product, user)
}

export function verMaisProdutos(config, store, product, user) {
  track('verMaisProdutos', { category: 'loja', name: store.name })
  log({ event: 'seeMoreProducts' }, config, store, product, user)
}

export function clickIfood(config, product, user) {
  const store = { name: 'all', cnpj: '00000000000000', stats: {} }
  track('ctaiFood')
  log({ event: 'clickIFood' }, config, store, product, user)
}

export function cliqueWhats(product) {
  track('cliqueWhats', { category: 'loja', name: product?.name })
}

export function iniciarConversarFormWhats() {
  track('iniciarConversarFormWhats', { category: 'Localizador de lojas' })
}

export function proximoFormWhats() {
  track('proximoFormWhats', { category: 'Localizador de lojas' })
}

export function voltarFormWhats() {
  track('voltarFormWhats', { category: 'Localizador de lojas' })
}

export function fecharFormWhats() {
  track('fecharFormWhats', { category: 'Localizador de lojas' })
}

export function permissaoSaibaMais() {
  track('permissaoSaibaMais')
}

export function digitarEndereco() {
  track('digitarEndereco')
}

export function compartilharEndereco(location) {
  track('compartilharEndereco', { category: 'menu', name: location?.city })
}

export function permissaoLocalNegada() {
  track('permissaoLocalNegada')
}

export function infoUtilSim() {
  track('infoUtilSim')
}

export function infoUtilNao() {
  track('infoUtilNao')
}
